/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'

const state = {
    ticketingForItems: {},
    ticketingForItem: {},
    isLoadingTable: false,
    showDeleteModal: false,
    // for log 
    showLogModal: false,
    ticketingForItemId: 0
}

const mutations = {
    getPaginatedData(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/ticketingforitems/page=${payload.page}&pageSize=${payload.pageSize}/${payload.sow}/${payload.itemType}/${payload.progressStat}/${payload.query}`).then(response => {
            response.data.data.forEach(tfi => {
                tfi.dateCreated = moment(tfi.dateCreated).format('MM/DD/YYYY HH:mm')
                tfi.lastModified = moment(tfi.lastModified).format('MM/DD/YYYY HH:mm')
            })
            state.ticketingForItems = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.ticketingForItem) {
            state.ticketingForItem = payload.ticketingForItem
        } else {
            state.ticketingForItem = {}
        }
    },
    openLogModal(state, payload) {
        state.showLogModal = payload.showLogModal
        if (payload.ticketingForItemId) {
            state.ticketingForItemId = payload.ticketingForItemId
        } else {
            state.ticketingForItemId = 0
        }
    }
}

const actions = {
    getPaginatedData({
        commit
    }, payload) {
        commit('getPaginatedData', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    },
    openLogModal({
        commit
    }, payload) {
        commit('openLogModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}